import React from 'react'
import { Button } from '../../../ui/button'
import { Title, Text1, Text2 } from '../../../ui/text'
import { Success, ErrorIcon } from '../../../../assets/icons'
import theme from '../../../../styled/theme'
import useIsMobile from '../../../../hooks/useIsMobile'
import { ScreenContainer, ButtonContainer, ExperienceTitle } from './styled'

const DEFAULT_SUCCESS_MESSAGE = '¡Gracias por responder!'
const DEFAULT_SUCCESS_SUBTITLE = 'Tus comentarios nos ayudan a mejorar la experiencia de gestión de turnos.'
const DEFAULT_ERROR_MESSAGE = 'Hubo un error al enviar tu respuesta, por favor intentá nuevamente.'
const DEFAULT_ERROR_SUBTITLE = 'Tu opinión nos ayuda a mejorar'

const SuccessScreen = ({ successMessage, hasError = false, onClose }) => {
	const isMobile = useIsMobile()

	return (
		<ScreenContainer>
			{hasError ? (
				<ErrorIcon size={64} color={theme.colors.feedback.error} />
			) : (
				<Success size={64} color={theme.colors.brand.green} />
			)}
			<Title color={theme.colors.text.primaryText} align="center">
				{hasError ? DEFAULT_ERROR_MESSAGE : successMessage || DEFAULT_SUCCESS_MESSAGE}
			</Title>
			<Text2 color={theme.colors.text.secondaryText} align="center">
				{hasError ? DEFAULT_ERROR_SUBTITLE : DEFAULT_SUCCESS_SUBTITLE}
			</Text2>
			{onClose && (
				<ButtonContainer>
					<Button label="Cerrar" $variant="primary" onClick={onClose} />
				</ButtonContainer>
			)}
		</ScreenContainer>
	)
}

export default SuccessScreen
